import React from "react";
import { useAtom } from "jotai";
import { motion } from "framer-motion";
import { themeAtom } from "../../../../../-Atoms";
import { db, doc, updateDoc } from "../../../../../firebaseConfig";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import RemoveIcon from "@mui/icons-material/Remove";

import UniversalTextField from "../../../../../GlobalComponents/UniversalTextField";

const BackgroundRollItemV2 = ({
  item,
  items,
  setItems,
  index,
  showRemoveBackgroundRollItem,
  jobData,
  isDragging = false,
}) => {
  const [theme] = useAtom(themeAtom);

  const handleItemNameChange = (newValue) => {
    const updatedItems = items.map((i, idx) =>
      idx === index ? { ...i, itemName: newValue } : i
    );
    setItems(updatedItems);
    // Save to Firestore
    updateDoc(doc(db, "JobData", jobData.id), { backgroundRolls: updatedItems })
      .catch((e) => console.log(e));
  };

  const handleQuantityChange = (newValue) => {
    const numericValue = newValue.replace(/[^0-9]/g, "");
    const updatedItems = items.map((i, idx) =>
      idx === index ? { ...i, quantity: numericValue } : i
    );
    setItems(updatedItems);
    // Save to Firestore
    updateDoc(doc(db, "JobData", jobData.id), { backgroundRolls: updatedItems })
      .catch((e) => console.log(e));
  };

  const removeBackgroundRollItem = () => {
    const updatedItems = items.filter((_, idx) => idx !== index);
    setItems(updatedItems);
    updateDoc(doc(db, "JobData", jobData.id), { backgroundRolls: updatedItems })
      .catch((e) => console.log(e));
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -10 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.2,
        ease: [0.25, 0.1, 0.25, 1.0],
      },
    },
  };

  return (
    <motion.div variants={itemVariants}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          width: "100%",
          borderRadius: "8px",
          backgroundColor: isDragging 
            ? (theme === "dark" 
                ? "rgba(100,150,255,0.25)" 
                : "rgba(100,150,255,0.30)") 
            : "transparent",
          padding: isDragging ? 1.5 : 0.5,
          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          cursor: "grab",
          border: isDragging 
            ? `1px solid ${theme === "dark" ? "rgba(100,150,255,0.4)" : "rgba(100,150,255,0.5)"}` 
            : "1px solid transparent",
          "&:hover": {
            backgroundColor: theme === "dark" 
              ? "rgba(255,255,255,0.03)" 
              : "rgba(0,0,0,0.03)",
          },
          "&:active": {
            cursor: "grabbing",
          },
        }}
      >
        <UniversalTextField
          value={item.quantity || ""}
          label="Quantity"
          onCallback={handleQuantityChange}
          adminOnly={false}
          sx={{
            width: "49%",
            marginTop: 0,
            "& .MuiInputBase-root": {
              fontSize: "15px",
            },
            "& .MuiInputLabel-root": {
              fontSize: "15px",
            },
          }}
          InputProps={{
            disableUnderline: true,
          }}
        />
        <UniversalTextField
          value={item.itemName || ""}
          label="Colour Name"
          onCallback={handleItemNameChange}
          adminOnly={false}
          sx={{
            width: "49%",
            marginTop: 0,
            "& .MuiInputBase-root": {
              fontSize: "15px",
            },
            "& .MuiInputLabel-root": {
              fontSize: "15px",
            },
          }}
          InputProps={{
            disableUnderline: true,
          }}
        />
        <IconButton
          sx={{
            display: showRemoveBackgroundRollItem ? "block" : "none",
            color:
              theme === "dark"
                ? "rgba(255,100,100,0.8)"
                : "rgba(200,50,50,0.8)",
            minWidth: "auto",
            width: "40px",
            height: "40px",
          }}
          onClick={removeBackgroundRollItem}
        >
          <RemoveIcon />
        </IconButton>
      </Box>
    </motion.div>
  );
};

export default BackgroundRollItemV2;
